import { ref }    from 'vue'
import { defineStore }      from 'pinia'
import { useConfigStore }   from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore }    from '@/stores/token'

export const useCertificatesStore = defineStore('certificates', () => {

    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const tokenStore        = useTokenStore()

    const certificates          = ref({})
    const certificatesProcess   = ref(false)
    const certificatesMsg       = ref({})

    const certificate           = ref({})
    const certificateProcess    = ref(false)
    const certificateMsg        = ref({})

    const certificateCreateProcess  = ref(false)
    const certificatesCreateMsg     = ref({})

    const certificatesUpdateProcess = ref(false)
    const certificatesUpdateMsg     = ref({})

    const certificatesDeleteProcess = ref(false)
    const certificatesDeleteMsg     = ref({})

    async function createCertificates(payload) {

        const token = tokenStore.access
        certificateCreateProcess.value = true

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/certificates`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                certificate.value = request
                certificatesMsg.value = {}
                certificatesCreateMsg.value = { success: true, text: 'CERTIFICATES_CREATE_SUCCESS', data: request }

            } else {
                certificatesCreateMsg.value = { success: false }
                certificatesCreateMsg.value.text = request.error
            }

            certificateCreateProcess.value = false

        } else {
            certificatesCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }
    }

    async function readCertificates(payload) {

        const token = tokenStore.access
        certificatesProcess.value = true

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/certificates${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                certificates.value = request
                certificatesMsg.value = { success: true }
            } else {
                certificates.value = {}
                certificatesMsg.value = { success: false }
                certificatesMsg.value.text = request.error
            }

        } else {
            certificatesMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        certificatesProcess.value = false
    }

    async function readCertificate(payload) {

        const token = tokenStore.access
        certificateProcess.value = true

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/certificates${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                certificate.value = request.array[0]
                certificateMsg.value = { success: true }
            } else {
                certificate.value = {}
                certificateMsg.value = { success: false }
                certificateMsg.value.text = request.error
            }

        } else {
            certificateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        certificateProcess.value = false
    }

    async function updateCertificates(payload) {

        const token = tokenStore.access
        certificatesUpdateProcess.value = true

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/certificates`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                certificate.value = request
                certificatesUpdateMsg.value = { success: true, text: 'CERTIFICATES_UPDATE_SUCCESS' }
            } else {
                certificatesUpdateMsg.value = { success: false }
                certificatesUpdateMsg.value.text = request.error
            }

        } else {
            certificatesCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        certificatesUpdateProcess.value = false
    }

    async function deleteCertificates(payload) {

        const token = tokenStore.access
        certificatesDeleteProcess.value = true

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/certificates/${payload.imei}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                certificatesDeleteMsg.value = { success: true, text: 'CERTIFICATES_DELETE_SUCCESS' }
            } else {
                certificatesDeleteMsg.value = { success: false, text: request.error }
            }

        } else {
            certificatesDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        certificatesDeleteProcess.value = false
    }

    const setCertificates           = data => certificates.value           = data
    const setCertificatesMsg        = data => certificatesMsg.value        = data
    const setCertificate            = data => certificate.value            = data
    const setCertificateMsg         = data => certificateMsg.value         = data
    const setCertificatesCreateMsg  = data => certificatesCreateMsg.value  = data
    const setCertificatesUpdateMsg  = data => certificatesUpdateMsg.value  = data
    const setCertificatesDeleteMsg  = data => certificatesDeleteMsg.value  = data

    return {

        certificates,
        certificatesProcess,
        certificatesMsg,
        certificate,
        certificateProcess,
        certificateMsg,
        certificateCreateProcess,
        certificatesCreateMsg,
        certificatesUpdateProcess,
        certificatesUpdateMsg,
        certificatesDeleteProcess,
        certificatesDeleteMsg,
        createCertificates,
        readCertificates,
        readCertificate,
        updateCertificates,
        deleteCertificates,
        setCertificates,
        setCertificatesMsg,
        setCertificate,
        setCertificateMsg,
        setCertificatesCreateMsg,
        setCertificatesUpdateMsg,
        setCertificatesDeleteMsg
    }
})
